import * as React from 'react'
import styled from 'styled-components'
import { tJa } from '../../../core/i18n'
import * as constants from '../../../static/constants'
import { IPaymentDetail } from '../../../static/interfaces'

interface IProps {
  paymentDetail?: IPaymentDetail | null
}

const ROWS: Array<{ key: keyof IPaymentDetail; i18nKey: string; negative?: boolean }> = [
  { key: 'guide_fee', i18nKey: 'guide_fee' },
  { key: 'calculated_special_activity_fee', i18nKey: 'special_activity_fee' },
  { key: 'calculated_large_group_fee', i18nKey: 'large_group_fee' },
  { key: 'other_fee', i18nKey: 'other_fee' },
  { key: 'travel_cost', i18nKey: 'travel_cost' },
  { key: 'calculated_advance_cost', i18nKey: 'advance_cost' },
  { key: 'deduction', i18nKey: 'deduction', negative: true },
  { key: 'cancellation_fee', i18nKey: 'cancellation_fee' },
]

const formatYen = (value: number): string => `¥${Number(value || 0).toLocaleString()}`

const PaymentConfirmModalBody: React.FC<IProps> = ({ paymentDetail }) => {
  const total = Number(paymentDetail?.total || 0)

  return (
    <Wrapper>
      <div className="rows">
        {ROWS.map(row => (
          <div className="row" key={row.key}>
            <span className="label">
              {tJa(`activerecord.attributes.payment_detail.${row.i18nKey}`)}
            </span>
            <span className="value">
              {row.negative ? '−' : ''}
              {formatYen(Number((paymentDetail?.[row.key] as number) || 0))}
            </span>
          </div>
        ))}
        <div className="row total">
          <span className="label">{tJa('generic.total')}</span>
          <span className="value">{formatYen(total)}</span>
        </div>
      </div>
      <p className="note">この業務について上記の金額をお支払いします。よろしいですか？</p>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .rows {
    margin-top: 0.8rem;
  }
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.2rem 0;
    border-bottom: solid 1px ${constants.COLORS.divider2};
    font-size: 1.5rem;

    .label {
      color: ${constants.COLORS.subText};
    }
    .value {
      font-weight: bold;
      color: ${constants.COLORS.black};
    }

    &.total {
      border-bottom: 0;
      border-top: solid 2px ${constants.COLORS.divider};
      .label,
      .value {
        font-size: 1.8rem;
        font-weight: bold;
        color: ${constants.COLORS.black};
      }
    }
  }
  .note {
    margin-top: 1.6rem;
    font-size: 1.4rem;
    color: ${constants.COLORS.black};
  }
`

export default PaymentConfirmModalBody
